import { getElectronAPI } from '@/utils/platform';

/** Open a URL in the system default browser (desktop shell IPC or window.open fallback). */
export async function openExternalUrl(url: string): Promise<void> {
  const api = getElectronAPI();
  if (api?.openExternal) {
    await api.openExternal(url);
    return;
  }
  window.open(url, '_blank', 'noopener,noreferrer');
}
